import { render, staticRenderFns } from "./VantDiscussSavePop.vue?vue&type=template&id=c5473542&"
import script from "./VantDiscussSavePop.vue?vue&type=script&lang=js&"
export * from "./VantDiscussSavePop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports